import React from 'react';

const AssortmentsPremiumSimpleIllustrationSvg = (props) => (
    <svg viewBox="0 0 176 176" {...props}>
        <path
            d="M61.86 127.4l10.7-33.93-14.22-.55-11.52 61.54c0 .11-.1.22-.15.33l4.21 3.35 2.93-1.08a24.18 24.18 0 0 1 .73-3.47c1.13-4.09 10-16.48 7.32-26.19z"
            fill="#c3c6cf"
        />
        <path
            d="M87.37 155.32l-6.5-62H66.73c1.14 11.82 4.42 24.84 5.83 31 2 8.9 7.88 30.26 7.88 32.09a30.34 30.34 0 0 0 2.56 1.73z"
            fill="#c3c6cf"
        />
        <path
            d="M130.5 91.9s18.43 32.12 18.43 36.75h-12.48l-15.57-26.12 4.52-8.26z"
            fill="#9b9ea7"
        />
        <path
            d="M114 96.19l11.12.86 4.61-1.05-4.59 32.52H114z"
            fill="#9b9ea7"
        />
        <path
            d="M120.1 33.9a8.53 8.53 0 0 1 7.06 7.79c.67 5.29 23.91 23.88 11 30.24z"
            fill="#6d717a"
        />
        <path
            d="M127.14 56l14.92 10.9s-2 13.84-16.54-1.5c-5.81-6.12-4.74-11.14 1.62-9.4z"
            fill="#282c35"
        />
        <path
            d="M98.37 59.86c-6.73 3-25.76-5-22.81-8.88 9-5.32 17-22.35 17-22.35L104 41.15c1.37 2 8.74-1.36 9.51-.31 1.43 1.89-4.79 14.4-15.14 19.02z"
            fill="#bf4c28"
        />
        <path
            d="M134.33 96s.5-16.09.5-25.25S127.14 56 127.14 56l-12.28.9c-5.55 2.61-4.69 8.82-4.69 8.82l.18 10.35h2.27l1.38 23.6v17.57h12.42a.78.78 0 0 0 .75-.58l1.22-4.61a.78.78 0 0 1 1.41-.2l3 5a.78.78 0 0 0 .66.37h10.85a.8.8 0 0 0 .72-1.07c-1.03-4.87-6.81-15.83-10.7-20.15zM113.55 40.83l-13.5-13.37-7.46 6s4.72 6.33 6.45 7.71c4.03 3.73 12.8-1.01 14.51-.34z"
            fill="#282c35"
        />
        <path
            d="M152.23 99.92l-48.6-93.33 1.77-.92L154 99a1 1 0 0 1-.42 1.35 1 1 0 0 1-1.35-.43z"
            fill="#282c35"
        />
        <path
            d="M83.52 21.31c2 3 7.54 12.69 15.52 19.84-1.49-1.39 2.65-6.73 18.83-11.62-1-1.89 3-4 2.4-5.21s-4.87.52-5.66-1 2.86-3.72 2.45-5.11-4.5.57-5.36-.43 3-4 2.41-5.2-4.5.57-5.31-.32 2.19-3.6 1.65-5.05-3.83.91-4.48-.32l-.65-1.24S92.59 7.52 83.87 17.14a3 3 0 0 0-.35 4.17z"
            fill="#f6682f"
        />
        <path
            d="M127.14 56l-.32-3.47c3.81.85 7.61-.24 6.41-11.42s-15.29-7.92-15.29-.12c0 3.08 3 6.29 3 9.49 0 1.87-.85 2.78-3 4.41a26.47 26.47 0 0 0-3.08 2s7.45 5.29 12.18 4.5.1-5.39.1-5.39z"
            fill="#9b9ea7"
        />
        <path
            d="M122.23 41.61c0-1.63 2.78-2 2.78.6 1.69 0 5-2 8.08-2-1.87-10.06-15.15-6.76-15.15.81 0 3.08 3 6.29 3 9.49 0-3.93 2.48-3.81 2.48-6.16.02-1.14-1.21-1.13-1.19-2.74z"
            fill="#282c35"
        />
        <path
            d="M110.35 76.08a19.88 19.88 0 0 0 3.51 8.57c7.58 11 30.12.49 31.45-3.5s-3.39-5.31-3.39-5.31l1.29 2.48s-8.67 4.33-21.65 4.33l-2.08-6.6z"
            fill="#9b9ea7"
        />
        <path
            d="M123.09 50.49c-.78-.67 1 4.41 3.95 4.41l-.22-2.36a8.75 8.75 0 0 1-3.73-2.05zM139.57 154.48c0 6.24 8.73 5.21 8.54 8.44h-15.92c-.21-11.38 1.55-30.14 4.25-34.27h12.48c.01 3.04-9.35 19.59-9.35 25.83zM123.82 162.92s-3.43-3.2-2.41-9.55c.59-3.66 1.81-14.83 3.72-24.87H114l.25 34.42z"
            fill="#282c35"
        />
        <path
            d="M121.87 162.7s-4.06-5.08-6.86-5.08-2.64 5.3-2.64 5.3z"
            fill="#45494e"
        />
        <path
            d="M46.82 154.46c-2.24 4.66-10.87 6.91-11.28 8.56H53.7a47.25 47.25 0 0 1 .12-6l-2.93 1.08z"
            fill="#6d717a"
        />
        <path fill="#282c35" d="M108 66.81v28.86l-17.98 4V74.75L108 66.81z" />
        <path
            d="M82.79 51C92.06 51 108 53.21 108 66.81c0 9.18-9.67 10.38-9.67 15.27 0 8.17 37.36 11 37.36 22.18S108 109 108 127.07c0 0-25.82-3-39-30.84S82.79 51 82.79 51z"
            fill="#9b9ea7"
        />
        <path
            d="M90.67 58.28a10.71 10.71 0 0 0-9.1 5.16 65.43 65.43 0 0 1 6.79 19.77h7.07c-.76-10.71-4.76-24.93-4.76-24.93z"
            fill="#c3c6cf"
        />
        <path
            d="M56 51c-6 0-10.5 7-11.17 11.38a1 1 0 0 0 1 1.08h13zM82.79 51c6 0 10.5 7 11.17 11.38a1 1 0 0 1-1 1.08H80z"
            fill="#282c35"
        />
        <path
            d="M66 105.13H52.66s3-16.71 6.66-25.15c0 0-3.29-19.24-3.29-29h26.85s-.19 21.63-3.38 29.33l7.13 24.83H72l-3-8.91z"
            fill="#c3c6cf"
        />
        <path
            d="M97 163c.19-1.69-9-1.78-9.48-6.38l-.14-1.31-4.38 2.83-2.35-2.27c-.14 1.77-1.38 5-1.38 7.15z"
            fill="#6d717a"
        />
        <path
            d="M59.48 79.94h20.18l.83 3.22H58.25s.58-1.59 1.23-3.22z"
            fill="#282c35"
        />
        <path
            d="M62.41 72.88l-31 45c-2.16 3.47-.84 4.13 1.88 1.22s33.44-40.31 33.44-40.31z"
            fill="#282c35"
        />
        <path
            d="M135.69 104.26c0-13-37.32-14-37.32-22.17v41.25c9.09 3.6 9.62 3.73 9.62 3.73.01-14.42 27.7-11.65 27.7-22.81z"
            fill="#d2d6df"
        />
        <path
            d="M60.64 127.07h-8.69l-5.13 27.39c0 .11 3.4 3.16 3.4 3.16z"
            fill="#282c35"
        />
        <path
            d="M40.26 88.76l1.6 5.07c1.46-1.59 3.42-5.27 5.43-9.52l-5.35-2.74z"
            fill="#62666d"
        />
        <path
            d="M46.16 63.44l-4.22 18.12 5.35 2.74C51.57 75.21 56 63.44 56 63.44z"
            fill="#c3c6cf"
        />
        <path
            d="M69.21 51H56s3 12.73 12.27 22a1.29 1.29 0 0 0 1.81 0c9.3-9.28 12.27-22 12.27-22z"
            fill="#62666d"
        />
        <path
            d="M62 51s-1.27 5.39-4.79 6.59a1.1 1.1 0 0 1-1.43-1.05V51zM77.3 51s1.27 5.39 4.79 6.59a1.1 1.1 0 0 0 1.43-1.05V51z"
            fill="#9b9ea7"
        />
        <path
            d="M52.61 153.53a4.82 4.82 0 0 0 0-1.61L42.06 95.1l-1.8-.33-1.61.87 7.69 57.27a4.82 4.82 0 0 0 .48 1.54l4.33 8.5z"
            fill="#f6682f"
        />
        <path
            fill="#9b9ea7"
            d="M49.703 92.58l.215 1.343-19.088 3.048-.215-1.343zM40.65 86.245l1.21 7.584-3.406.544-1.211-7.584a.87.87 0 0 1 .722-.996l1.708-.273a.87.87 0 0 1 .997.722z"
        />
        <path
            d="M37.44 88c-.07 1.84-3.95 2.69-3.59 6.28a20.77 20.77 0 0 0 1.79 6.48s3.13-1.8 2.82-6.43z"
            fill="#62666d"
        />
        <path
            d="M67.84 31s-2.09-6.48-7.78-6.48c-7.88 0-12.13 12.67-17.56 12.67-7.32 0-11.33-9.85-19.5-9.85-6.59 0-10 10.28-11.1 14.24a.54.54 0 0 0 .84.58c1.31-1 3.41-2.29 4.91-2.29 8.17 0 11.75 12.25 18.44 12.25 12 0 18.65-23.51 24.11-23.51 3.41 0 5.54 3 5.54 3z"
            fill="#f6682f"
        />
        <path
            d="M63.74 42.49s-5.75-6.58.7-10.82c6-4 10.79.42 11 3.61s-11.7 7.21-11.7 7.21z"
            fill="#6d717a"
        />
        <path
            d="M75.56 51l-.8-2.14s3.89-3.19 3.89-7.27c0-12-15.49-10.75-15.49-2.49 0 4.55 2.82 6.38 1.74 8.59S63.18 51 63.18 51a11.24 11.24 0 0 0 6.48 1.76c4.17-.02 5.9-1.76 5.9-1.76z"
            fill="#c3c6cf"
        />
        <path
            d="M79 36.11l-12 3.4c-.65.19-1.22.55-1.22 1.22s.58 1 1.22 1.22l12.39 3c2.5-4.22-.39-8.84-.39-8.84z"
            fill="#6d717a"
        />
        <circle cx={58.44} cy={53.24} r={0.8} fill="#d2d6df" />
        <circle cx={81.06} cy={53.24} r={0.8} fill="#d2d6df" />
        <path
            d="M87.49 101.12a47.63 47.63 0 0 0-19.26 4.51 2.19 2.19 0 0 0-1.25 2v16.12c0 24.64 20.51 39.33 20.51 39.33S108 148.38 108 123.74v-16.13a2.19 2.19 0 0 0-1.25-2 47.63 47.63 0 0 0-19.26-4.49z"
            fill="#f6682f"
        />
        <circle
            cx={87.37}
            cy={120.98}
            r={9}
            transform="rotate(-45.08 87.382 120.987)"
            fill="#ffa71a"
        />
        <path
            d="M88.36 83.21a64.51 64.51 0 0 1 1.09 13.46L85 101.12h1.41c-.1 3-.28 6.24 1.45 4.88a22.33 22.33 0 0 0 4.27-4.89 32.2 32.2 0 0 0 3.38-14.68c0-1 0-2.11-.12-3.23z"
            fill="#62666d"
        />
        <path
            d="M163.75 164.07H15.63a1 1 0 1 1 0-2h148.12a1 1 0 0 1 0 2z"
            fill="#282c35"
        />
    </svg>
);

AssortmentsPremiumSimpleIllustrationSvg.displayName =
    'AssortmentsPremiumSimpleIllustrationSvg';
export default AssortmentsPremiumSimpleIllustrationSvg;
